import { render, staticRenderFns } from "./Why.vue?vue&type=template&id=f3e20f76"
import script from "./Why.vue?vue&type=script&lang=js"
export * from "./Why.vue?vue&type=script&lang=js"
import style0 from "./Why.vue?vue&type=style&index=0&id=f3e20f76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports